import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import TenableVulnerabilityManagementCredentialsForm from "./TenableVulnerabilityManagementCredentialsForm";
import TenableVulnerabilityManagementConfigListing from "./TenableVulnerabilityManagementConfigListing";

export default function TenableVulnerabilityManagementPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={TenableVulnerabilityManagementCredentialsForm}
      PullConfigListingView={TenableVulnerabilityManagementConfigListing}
    />
  );
}
